// increased from 8000 as a short term "solution" to ii-221
// TODO: find a proper solution to not "blindly" poll test results
export const API_FETCH_INTERVAL = 20000;
export const API_FETCH_THROTTLE = 500;

export const JOBS_DEFAULT_PARAMS = {
  auto_only: true,
  full: true,
  limit: 50,
};
